import { CSSProperties, cx } from '@linaria/core';
import { activeGreen } from '../theme';
import "./PercentageBar.linaria.module.css!=!./PercentageBar?./PercentageBar.linaria.module.css?css=H4sIAAAAAAAAA22SzW6DMAzH73sKLpNaqVQE2lLYi+wWBZJASohDkgYY2rtPHYW1227++P1ty/aeuBb7ESOwHcR+6gV1dY6i6PXt82V/S7IYo6zwoGGqmahql6NID0s24dgzxJCaCjCUmRzpIbAgBQ08MZswnMNhCRLMLqgMY2q7iGOKh/jQlE/OVJCyqQxcFZ1Vubx1rQwZF13b4Dpu28tp0mCFE6BywyRxwrMFySxGV8kGXkxUWC3JmBcSymbJNxajo+/63kzgmeES+rwWlDK1EIiP1PjjspnAaqL+WQ86pTJLOLZO9efzTK1TkcKCvLp1KpKUx48SC6p5dZhZBzqP1mI+oSetngDJuPsh4jqJ7eUJKMA5aB+KpGcTC4JR13ngcG9jiLoP9W1yMG0Q7Q82kEIxYhaxMzhNZSeKacVmgSSOvW/mm66BcNgFkR62jxdFKJEdzX65f696f49f4YcX+QIziTzMmwIAAA=="
const stylesRoot = "atm_vy_1osqo2v atm_e2_19bvopo";
const linearProgress = "atm_3f_ve1e1n atm_2d_x24kc atm_e2_19bvopo atm_mk_h2mmj6 atm_9s_1ulexfb atm_ks_15vqwwr atm_1fydrv5_1osqo2v atm_167l93f_stnw88 atm_a3c5zc_idpfg4 atm_1v3d6pn_idpfg4 atm_2h32sj_idpfg4 atm_178r2ia_1qqvofo";
const linearProgressInner = "atm_tr_77lqib atm_2d_113lqd9";
type PercentageBarProps = {
  classNameLinearProgressInner?: string;
  classNameLinearProgress?: string;
  percentage: number;
  color?: string;
};
const PercentageBar = (props: PercentageBarProps) => {
  const {
    classNameLinearProgressInner,
    classNameLinearProgress,
    color = activeGreen,
    percentage
  } = props;
  const offset = percentage - 100;
  const displayColor = color === '#000000' || color === undefined ? activeGreen : color;
  return <div className={stylesRoot}>
            <span style={{
      '--translate-x': `${offset}%`,
      '--border-color': displayColor
    } as CSSProperties} className={cx(linearProgress, ...[].concat(classNameLinearProgress))}>
                <span style={{
        '--translate-x': `${offset}%`,
        '--background-color': displayColor
      } as CSSProperties} className={cx(linearProgressInner, ...[].concat(classNameLinearProgressInner))} />
            </span>
        </div>;
};
export default PercentageBar;